import * as Actions from '../actions/actions'

let soundMonitorTimer, 
    isPlaying = false;  // http://stackoverflow.com/a/40370077

export function playSound (store, settings, url, ttsInstance, ttsMimeTypes, force) {

  if (force === undefined) {
      force = false;
  }
  var chatTTSEnabled = getAgentSetting(settings, 'chatTTSEnabled', true);
  var onlyUseFlashAudio = getAgentSetting(settings, 'onlyUseFlashAudio', false);
  var clearSoundAfterStart = getAgentSetting(settings, 'clearSoundAfterStart', true);

  if (!url || typeof url !== 'string') {
      console.log('Error playing sound.  The specified URL is invalid.');
      stopSound(store, settings);
  } else if ((force || getSoundEnabled(store,settings)) && chatTTSEnabled) {
      console.log('Playing Sound: ' + url);
      var queryParams = '&TTSMediaHandlerInstanceID=' + ttsInstance;
      var mediaId = getAgentSetting(settings, 'ttsMediaId', 'aagent_movie');
      var flashMediaSource = url + queryParams + '&mimeType=application/x-shockwave-flash&TTSMimeTypes=application/x-shockwave-flash';

      var audio = getAudioElement(settings);
      // Wrap in try catch for browsers that do not support html5 audio.
      try {
          if (isPlaying) audio.pause();
          audio.innerHTML = '';
      } catch (e) { }

      appendAudioTypes(audio, url, queryParams, ttsMimeTypes);

      if (onlyUseFlashAudio) {
          audio && audio.parentNode.removeChild(audio);
          let ttsElement = getTTSElement(settings);
          ttsElement.innerHTML += getFlashObjectHtml(mediaId, flashMediaSource);
          setWasPlayed(store, settings, true);
          displayAudioControlsHidden(store, settings);
      } else {
          if (!canPlayAudioTypes(ttsMimeTypes)) {
              // The browser should default to flash (IE8 and below).
              // Show the element or flash will not play.
              // This also uses the IE8 and below specific style attributes to hide the element.
              // See AlmeSound.css #aagent_tts for an example.
              // Append swf audio.
              fallbackToFlash(audio, settings, ttsMimeTypes, mediaId, flashMediaSource);
          }

          // Wrap in try catch for browsers that do not support html5 audio.
          try {
              audio.load();
              audio.play();
          } catch (e) { }
      }
      setShouldPlay(store, settings, true);

      if (clearSoundAfterStart) {
          updateLastPrvUrl(store, settings, '');
      }

      soundMonitorTimer=getSoundMonitorTimer(store,settings);
      if (soundMonitorTimer) {
          clearTimeout(soundMonitorTimer);
      }

      // Have to use SetTimeout initially, due to a FireFox issue (object isn't initialized right away)
      setSoundMonitorTimer(store, settings, setTimeout(function(){
          monitorSoundFinish(store, settings)}, 30)); // Checks for the end of playing, so it can start playing the next sound.
      return true;
  }
  return false;
}



export function stopSound (store, settings) {
  console.log('Stopping Sound...');
  //using toggleSound(false) updates the sound settings on UI so can't use that

  var audio = getAudioElement(settings);
  var flashObj = getMovieElement(settings);
  // Wrap in try catch for browsers that do not support html5 audio.
  try {
      if (isPlaying) audio.pause();
  } catch (e) { }

  audio.innerHTML = '';
  flashObj && flashObj.parentNode.removeChild(flashObj);
  setWasPlayed(store, settings, false);
  setShouldPlay(store, settings, false);
}

export function updateLastPrvUrl(store, settings, prvUrl, ttsInstance, ttsMimeTypes)
{
  var payload = { prvUrl };
  if (ttsInstance) {
      payload.ttsInstance = ttsInstance;
  }
  if (ttsMimeTypes) {
      payload.ttsMimeTypes = ttsMimeTypes;
  }
  let location=settings.stateLocations.TTS.lastPrvUrl;
  store.dispatch(Actions.setStateLastPrvUrl(payload, location));
}

export function updatePlayPrvOnNav(store, settings, update)
{
    let location=settings.stateLocations.TTS.playPrvOnNav;
    store.dispatch(Actions.setStatePlayPrvOnNav(update,location));
}

export function isAppleMobileDevice  () {
    return !!navigator.userAgent.match(/iP(hone|od|ad)/i);
}

export function displayAudioControlIfNotPlayed (store, settings) {
    if (!wasPlayed(store, settings) && shouldPlay(store, settings) && getSoundEnabled(store, settings)) {
        try {
            let audio = getAudioElement(settings);
            if (!isPlaying) audio.load();
        } catch (e) { }

        window.clearTimeout(getAudioPlayTimer(store,settings));
        setWasPlayed(store,settings,true);
    }
}

function displayAudioControlsHidden(store, settings) {
    let ttsElement= getTTSElement(settings);
    if (ttsElement) {
        ttsElement.style.height = '0px';
        ttsElement.style.width = '0px';
    }
}

function getSoundMonitorTimer(store, settings){
  let state = store.getState();
    return state
      [settings.stateLocations.TTS.Base]
      [settings.stateLocations.TTS.soundMonitorTimer];
}

function setSoundMonitorTimer(store,settings, timer) {
    let location=settings.stateLocations.TTS.soundMonitorTimer;
    store.dispatch(Actions.setStateSoundMonitorTimer(timer,location));
}

function fallbackToFlash(audio, settings,ttsMimeTypes, mediaId, flashMediaSource) {
    let flashMime = 'application/x-shockwave-flash';
    if (Array.isArray(ttsMimeTypes) && ttsMimeTypes.indexOf(flashMime) !== -1) {
        audio.innerHTML += getFlashObjectHtml(mediaId, flashMediaSource);
    }
}

function getFlashObjectHtml(mediaId, flashMediaSource) {
    let flashObj = document.getElementById(mediaId);
    if (flashObj) {
        flashObj && flashObj.parentNode.removeChild(flashObj);
    }

    return '<object id="' + mediaId + '" codebase="https://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=4,0,0,0" width="2" height="1" type="application/x-shockwave-flash"' +
        'data="' + flashMediaSource + '">' +
        '<param name="movie" value="' + flashMediaSource + '"/>' +
        '<param name="scale" value="noscale"/>' +
        '<param name="salign" value="tl"/>' +
        '<param name="play" value="true"/>' +
        '<param name="loop" value="false"/>' +
        '<param name="allowscriptaccess" value="always">' +
        '</object>';
}

function appendAudioTypes (audio, url, queryParams, ttsMimeTypes) {
    if (!Array.isArray(ttsMimeTypes)) return;

    ttsMimeTypes.forEach((mimeType) => {
        var mimeTypeParams = '&mimeType=' + mimeType + '&TTSMimeTypes=' + mimeType;
        audio.appendChild(createSource(url + queryParams + mimeTypeParams, mimeType));
    });
}

function createSource(mediaSource, mimeType) {
    let tag = document.createElement('source');
    tag.setAttribute('src', mediaSource);
    tag.setAttribute('type', mimeType);
    return tag;
}

function canPlayAudioTypes (audioTypes) {
    for (var i = 0; i < audioTypes.length; i++) {
        var a = document.createElement('audio');
        if (!a.canPlayType) {
            // Exit the loop.  canPlayType is not a function.
            return false;
        } else if (a.canPlayType(audioTypes[i])) {
            return true;
        }
    }
    return false;
}

function getSoundEnabled(store, settings)
{
  let state = store.getState();
    return state
      [settings.stateLocations.Window.Base]
      [settings.stateLocations.Window.IsSound];
}

export function getAgentSetting (settings, name, defVal)
{
  if (settings.TTS && settings.TTS[name] !== undefined)
  {
    return settings.TTS[name];
  }
  return defVal;
}

function getTTSElement(settings) {
    let ttsDivId = getAgentSetting(settings, 'ttsDivId', 'aagent_tts');
    return document.getElementById(ttsDivId);
}

function getAudioElement(settings) {
    let ttsAudioId = getAgentSetting(settings, 'ttsAudioId', 'aagent_audio');
    return document.getElementById(ttsAudioId);
}

function getMovieElement(settings) {
  let ttsMediaId = getAgentSetting(settings, 'ttsMediaId', 'aagent_movie');
  return document.getElementById(ttsMediaId);
}

function wasPlayed(store, settings)
{
  let state = store.getState();
    return state
      [settings.stateLocations.TTS.Base]
      [settings.stateLocations.TTS.wasPlayed];
}
function shouldPlay(store, settings)
{
  let state = store.getState();
    return state
      [settings.stateLocations.TTS.Base]
      [settings.stateLocations.TTS.shouldPlay];
}
function getAudioPlayTimer(store,settings)
{
  let state = store.getState();
    return state
      [settings.stateLocations.TTS.Base]
      [settings.stateLocations.TTS.audioPlayTimer];
}

export function setAudioPlayTimer(store, settings, playTimer)
{
  let location=settings.stateLocations.TTS.audioPlayTimer;
  store.dispatch(Actions.setStateAudioPlayTimer(playTimer,location));
}

export function setShouldPlay(store, settings, should)
{
  let location = settings.stateLocations.TTS.shouldPlay;
  store.dispatch(Actions.setStateShouldPlay(should,location));
}
export function setWasPlayed(store, settings, was)
{
  let location = settings.stateLocations.TTS.wasPlayed;
  store.dispatch(Actions.setStateWasPlayed(was,location));
}

function monitorSoundFinish(store,settings) {
    var movie = getMovieElement(settings);
    try {
        /** {@link http://bugs.adobe.com/jira/browse/FP-240|Adobe JIRA} */
        if (document.title.indexOf('#') >= 0) {
            document.title = document.title.replace('#', '');
        }

        // Have to check for null, since StopSound will remove the object and cause an error here (we can't check movie.IsPlaying for existance due to IE)
        // TODO: move.IsPlaying() appears to always be false.
        if (movie && movie.IsPlaying) {
            if (movie.IsPlaying()) {
                soundMonitorTimer = setTimeout(() => { 
                    monitorSoundFinish(store,settings) 
                }, 30);
            } else {
                // Clear the object to prevent CPU infinite loop leak for flash objects.
                stopSound(store,settings);
            }
        } else {
            // function is not supported.
          console.log('Unable to monitor for flash sound finish.');
        }
    } catch (e) {
        console.log('Error while monitoring for sound finish: ' + getErrorMessage(e));
    }
}

function getErrorMessage(e)
{
  if (typeof e !== 'undefined' && e) {
     if (e.message) {
         // IE6, IE7, FF3
         if (e.stack) {
             console.log(e.stack);
         }
         return e.message;
     } else {
         // FF1, FF1.5, FF2, FF3
         return e.toString();
     }
 }
 return '';
}

export function getIsPlaying() {
    return isPlaying;
}

export function setIsPlaying(newValue) {
    isPlaying = newValue;
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-tts/src/utils/index.js